export default "__VITE_ASSET__DbCAseop__"